/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { repository, session } from "~/clientInstance";
export const isOctopusIdEnabled = async (): Promise<boolean> => {
    const currentUserId = session && session.currentUser ? session.currentUser.Id : null;
    const configDoc = await repository.UserIdentityMetadata.authenticationConfiguration(currentUserId!);
    return !!configDoc.AuthenticationProviders && !!configDoc.AuthenticationProviders.find((p) => p.Name === "Octopus ID");
};
